module.exports = __webpack_public_path__ + "img/dashboard1.ebb861d7.svg";